import { BreakpointObserver } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NotificationType } from '@app/shared/interfaces';
import { PrioritySupportQuote, SettingsService } from '@app/shared/services/settings/settings.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-support-tier-change',
  templateUrl: './dialog-support-tier-change.component.html',
  styleUrls: ['./dialog-support-tier-change.component.scss'],
})
export class DialogSupportTierChangeComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogSupportTierChangeComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      newPlan: 'basic' | 'premium' | 'keep-priority-support';
    },
    private settingsService: SettingsService,
    private toast: ToastNotificationsService,
    private auth: AuthenticationService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  stage: number = 1;
  cancelling: boolean = false;
  upgrading: boolean = false;
  hasCheckedCancelBox: boolean = false;
  hasCheckedUpgradeBox: boolean = false;
  loadingQuote: boolean = false;
  keepPrioritySupportChecked: boolean = false;

  quote: PrioritySupportQuote = null;

  user = this.auth.getUserDetails();

  isMobile$ = this.breakpointObserver.observe(['(max-width: 960px)']).pipe(map((res) => res.matches));

  ngOnInit() {
    this.loadingQuote = true;
    this.settingsService.getPrioritySupportQuote().subscribe((res) => {
      this.loadingQuote = false;
      this.quote = res;
    });
  }

  keepPrioritySupport() {
    if (!this.keepPrioritySupportChecked) {
      this.toast.open(
        'Please check the box to confirm you want to keep your priority support.',
        'OK',
        NotificationType.Error
      );
      return;
    }

    this.dialogRef.close(true);
  }

  confirmDowngrade() {
    if (!this.hasCheckedCancelBox) {
      this.toast.open(
        'Please check the box to confirm you want to cancel your priority support.',
        'OK',
        NotificationType.Error
      );
      return;
    }

    this.cancelling = true;
    this.settingsService.cancelPrioritySupport().subscribe(
      () => {
        this.cancelling = false;
        this.dialogRef.close(true);
      },
      (err) => {
        this.cancelling = false;
      }
    );
  }

  upgrade() {
    if (!this.hasCheckedUpgradeBox) {
      this.toast.open(
        'Please check the box to confirm you want to upgrade your priority support.',
        'OK',
        NotificationType.Error
      );
      return;
    }

    this.settingsService.upgradeToPrioritySupport().subscribe(
      () => {
        this.upgrading = false;
        this.stage++;

        const url = this.router
          .createUrlTree(['/settings/support-tiers/success'], {
            relativeTo: this.route,
          })
          .toString();

        this.location.go(url);
      },
      (err) => {
        this.upgrading = false;
      }
    );
  }
}
